// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__e9JWM","notes":"Notes_notes__1Nyj4","note":"Notes_note__2w88N","markdown":"Notes_markdown__3Gcvz"};